export default __webpack_public_path__ + "logo_en.c1725330.svg";